import { BACK_ABOUT } from "../assets/image";

export function Integration({ texts }: any) {
  return (
    <div
      id="integration"
      className={`relative min-h-screen w-full bg-cover bg-no-repeat bg-right-top flex`}
      style={{
        backgroundImage: `url(${BACK_ABOUT})`,
        backgroundSize: "cover",
      }}
    >
      <div className="container m-auto p-10  text-left">
        <div className="flex justify-center items-center">
          {" "}
          <div className="w-2/3">
            <h5 className="text-lg text-[#e04f39] uppercase mb-4">
              {texts.title}
            </h5>
            <h1 className="text-5xl font-black text-white mb-8">
              {texts.subtitle}
            </h1>
            <div className="text-lg font-light text-white mb-8">
              {texts.content}
            </div>
          </div>
          <div className="w-full" />
        </div>
      </div>
    </div>
  );
}
export default Integration;
